import BarcodeComponent from "./BarcodeComponent";

const Card = ({ code, height = 100, hasBorderBottom = false }) => {
  return (
    <span
      style={{
        padding: "10px",
        borderBottom: hasBorderBottom === true ? "1px dotted black" : "none",
      }}
    >
      <BarcodeComponent key={code} height={height} code={code} />
    </span>
  );
};

export default Card;
